module.exports = __webpack_public_path__ + "img/emoji_21.67edbf5c.png";